import additionalMessages from '../../messages';

export type SiteImportGroupKind = 'network_sites' | 'subscriber_sites';

const SAMPLE_SITES_CSV_URLS: Record<SiteImportGroupKind, string> = {
  network_sites: '/sample/Network_Sites_Sample.csv',
  subscriber_sites: '/sample/Subscriber_Sites_Sample.csv',
};

const IMPORT_ERROR_MESSAGE_IDS: Record<SiteImportGroupKind, string> = {
  network_sites: 'importCSV.errorMessageNetwork',
  subscriber_sites: 'importCSV.errorMessageSubscriber',
};

export function isNetworkSiteGroup(
  groupKind: string
): groupKind is SiteImportGroupKind {
  return groupKind === 'network_sites';
}

export function getSampleSitesCsvUrl(groupKind: string) {
  const sampleSitesCsvUrl =
    SAMPLE_SITES_CSV_URLS[
      isNetworkSiteGroup(groupKind) ? groupKind : 'subscriber_sites'
    ];

  return process.env.NODE_ENV === 'development'
    ? sampleSitesCsvUrl
    : `/assets${sampleSitesCsvUrl}`;
}

export function getImportModalTitleMessage(groupKind: string) {
  return isNetworkSiteGroup(groupKind)
    ? additionalMessages.importNetworkSites
    : additionalMessages.importSubscriberSites;
}

export function getImportErrorMessageId(groupKind: string) {
  return IMPORT_ERROR_MESSAGE_IDS[
    isNetworkSiteGroup(groupKind) ? groupKind : 'subscriber_sites'
  ];
}
